<template>
  <BareFullScreenPopup
    ref="popup"
    :closeable="false"

  >
    <div class="contract-processing-popup">
      <p class="contract-processing-popup__title">Відбувається процес формування договору</p>
      <p class="contract-processing-popup__text">Це займає від 10 до 60 секунд</p>
      <div class="contract-processing-popup__loader">
        <SpinnerLoader
          color="#0A77FF"
          :scale="3"
        />
      </div>
    </div>
  </BareFullScreenPopup>
</template>

<script>
import { SpinnerLoader } from '@/shared/ui/loader';
import { BareFullScreenPopup } from '@/shared/ui/popup';

export default {
  name: 'ContractProcessingPopup',
  components: { BareFullScreenPopup, SpinnerLoader },
  methods: {
    open() {
      this.$nextTick(() => {
        this.$refs.popup.open();
      });
    },
    close() {
      this.$refs.popup?.close();
    },
  },
};
</script>

<style scoped lang="scss">
.contract-processing-popup {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 16px 40px;
  max-width: 500px;

  &__title {
    font-size: 20px;
    font-weight: 500;
  }

  &__text {
    font-size: 16px;
    font-weight: 500;
    color: #717680;
    text-align: center;
  }

  &__loader {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 24px;
  }
}
</style>
